import { useQuery } from '@tanstack/react-query'

import { MessagingQueryKey } from '../../keys'
import messagingService from '../services'

export default function useQueryGetFlexMessageAnalytics() {
	return useQuery({
		queryKey: [MessagingQueryKey.GetFlexMessageAnalytics],
		queryFn: () => messagingService.getFlexMessageAnalytics(),
	})
}
